import React, { useState } from 'react';
import { budgetData, summaryData } from '../data/budgetData';
import { Condition, BudgetLineItem as BudgetLineItemType } from '../types/budget';
import { SummaryBar } from '../components/SummaryBar';
import { CategorySidebar } from '../components/CategorySidebar';
import { CategoryDetail } from '../components/CategoryDetail';
import { ConditionModal } from '../components/ConditionModal';
export function BudgetReview() {
  const [conditions, setConditions] = useState<Condition[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>(budgetData[0].id);
  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCondition, setEditingCondition] = useState<Condition | null>(null);
  const [selectedContext, setSelectedContext] = useState<{
    categoryId: string;
    categoryName: string;
    lineItem: BudgetLineItemType;
  } | null>(null);
  const selectedCategory = budgetData.find(c => c.id === selectedCategoryId) || budgetData[0];
  const categoryConditions = conditions.filter(c => c.categoryId === selectedCategoryId);
  const handleAddConditionClick = (item: BudgetLineItemType) => {
    setSelectedContext({
      categoryId: selectedCategory.id,
      categoryName: selectedCategory.name,
      lineItem: item
    });
    setEditingCondition(null);
    setIsModalOpen(true);
  };
  const handleEditConditionClick = (condition: Condition) => {
    setEditingCondition(condition);
    setSelectedContext({
      categoryId: condition.categoryId,
      categoryName: condition.categoryName,
      lineItem: {
        id: condition.lineItemId,
        name: condition.lineItemName
      } as BudgetLineItemType
    });
    setIsModalOpen(true);
  };
  const handleSaveCondition = (note: string, priority: Condition['priority']) => {
    if (editingCondition) {
      setConditions(prev => prev.map(c => c.id === editingCondition.id ? {
        ...c,
        note,
        priority
      } : c));
    } else if (selectedContext) {
      const newCondition: Condition = {
        id: `cond-${Date.now()}`,
        lineItemId: selectedContext.lineItem.id,
        categoryId: selectedContext.categoryId,
        lineItemName: selectedContext.lineItem.name,
        categoryName: selectedContext.categoryName,
        note,
        priority,
        status: 'pending',
        createdAt: new Date().toISOString()
      };
      setConditions(prev => [...prev, newCondition]);
    }
  };
  return <div className="h-screen w-full flex flex-col bg-white font-body overflow-hidden" data-id="element-108">
      <SummaryBar data={summaryData} totalConditions={conditions.length} data-id="element-109" />

      <div className="flex-1 flex overflow-hidden" data-id="element-110">
        <CategorySidebar categories={budgetData} selectedId={selectedCategoryId} onSelect={setSelectedCategoryId} conditions={conditions} data-id="element-111" />

        <CategoryDetail category={selectedCategory} conditions={categoryConditions} onAddCondition={handleAddConditionClick} onEditCondition={handleEditConditionClick} data-id="element-112" />
      </div>

      <ConditionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSaveCondition} initialData={editingCondition} contextName={selectedContext ? `${selectedContext.categoryName.replace(/^TOTAL\s+/i, '')} > ${selectedContext.lineItem.name}` : ''} data-id="element-113" />
    </div>;
}